<template>
  <component :is="componentType" v-bind="{ ...propTypes }"><slot /></component>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import ShLink from '~/components/sh-link'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'sc-clickable',
  components: { ShLink },
  props: ['href', 'target'],
  computed: {
    ...mapJssGetters([
      'isEditMode'
    ]),
    isClickable () {
      return !this.isEditMode && this.href
    },
    componentType () {
      if (this.isClickable) return 'sh-link'

      return 'div'
    },
    propTypes () {
      if (this.componentType === 'div') return {}

      return {
        to: this.href,
        target: this.target
      }
    }
  }
}
</script>


<style lang="scss" scoped></style>
